import { Row } from 'antd';
import { createElement } from 'react';
import './index.scss';
const DCRow = function DCRow({ gutter, vGutter, children, style = {}, ...otherProps }) {
    const _style = style || {};
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    let _gutter = gutter || 0;
    if (vGutter !== undefined) {
        _gutter = [_gutter, vGutter];
    }
    _otherProps.gutter = _gutter;
    return createElement(Row, { ..._otherProps }, children);
};
DCRow.displayName = '行组件';
export default DCRow;
